import React from 'react';

// Styles & Assets
import styles from './Input.module.css';
import { DefaultTFuncReturn } from 'i18next';

// Interfaces
type TypeInput = 'text' | 'password' | 'number';

// Input: Renders a styles input of type text. On focus it moves the
// placeholder to the top border. Props received:
//  -label: string with the input label,
//  -value (optional): value of the input text,
//  -onChange: function that handles the changes on the input.
const Input: React.FC<{
    id?: string
    label?: string | DefaultTFuncReturn,
    defaultValue?: string | number,
    error?: boolean,
    errorMsg?: string | null,
    placeholder?: string
    onChange: React.ChangeEventHandler<HTMLInputElement>
    onBlur?: () => void
    required?: boolean,
    type?: TypeInput,
    step?: number
    simpleStyles?: true
}> = ({ id, label = '', defaultValue, error, errorMsg, placeholder = '', onChange, onBlur, required, type = 'text', step, simpleStyles }) => {

    return (
        <div className={styles.inputWrapper}>
            <div className={simpleStyles ? styles.simpleTextField : styles.textField}>
                <input
                    id={id}
                    type={type} placeholder={placeholder}
                    role="presentation"
                    autoComplete="new-password"
                    step={step ?? 0.1}
                    className={`${simpleStyles ? styles.simpleInput : type === 'number' ? styles.inputNum : styles.input} ${error ? 'errorOutline' : ''}`}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    onBlur={onBlur}
                    onWheel={(e) => e.currentTarget.blur()} 
                />
                <label className={simpleStyles ? styles.simpleLabel : type === 'number' ? styles.labelNum : styles.label} >
                    {label} {required && <p>*</p>}
                </label>
            </div>
            {errorMsg && <p className={styles.errorMsg}>{errorMsg}</p>}
        </div>
    );
};

export default Input;